// GENERATED FILE - DO NOT MODIFY
export enum WorkOrderActivityType {
    Labour = 1,
    Material = 2,
    Equipment = 3,
}

export let nameof = "WorkOrderActivityType";
